const commonView = () => import(/* webpackChunkName: "common" */ '@/components/common/commonView.vue')
const usermsg = () => import(/* webpackChunkName: "personalCenter" */ '@/views/personal-center/usermsg.vue')
const fixpass = () => import(/* webpackChunkName: "personalCenter" */ '@/views/personal-center/fixpass.vue')
const gamerule = () => import(/* webpackChunkName: "personalCenter" */ '@/views/personal-center/gamerule.vue')

const personalCenterLeading = {
  path: 'personal-center',
  name: 'personal-center',
  meta: { title: '个人中心', Submenu: true, menuOpenid: "15" },
  redirect: '/main/:GD/personal-center/usermsg',
  component: commonView,
  children: [
    {
      path: 'usermsg',
      component: usermsg,
      name: 'usermsg',
      meta: { title: '个人资讯' }
    },
    {
      path: 'fixpass',
      component: fixpass,
      name: 'fixpass',
      meta: { title: '修改密码' }
    },
    {
      path: 'gamerule',
      name: 'gamerule',
      component: gamerule,
      meta: { title: '游戏规则' },
    },
  ]
}

export default personalCenterLeading